// Searchbar desktop
$(document).ready(function(){
  $(".nav-desktop-search").click(function(){
      $(".desktop-search").toggle();
      $(".desktop-search-hide").toggleClass("hide");
  });
  $('.drawerBackdrop').click(function() {
    $('.menuDrawerTrigger').click();
  });
  $('.drawerClose').click(function() {
    $('.menuDrawerTrigger').click();
  });

// PDP Popup
$(document).on('click', '.js-pdp-popup__overlay', function() {
  $(this).parents('.pdp-popup.active').removeClass('active');
  $('html').removeClass('modal-open');
});

$(document).on('click', '.js-pdp-popup__close', function() {
  $(this).parents('.pdp-popup.active').removeClass('active');
  $('html').removeClass('modal-open');
});

// Ajax Cart
$(document).on('click', '.add-to-cart--checkout', function () {
  var data = $(this).parents('form').serialize();

  fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      window.location.href = "/checkout";
    }.bind(this));
});
});

function getFocusableElements(container) {
return Array.from(
  container.querySelectorAll(
    "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
  )
);
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
var elements = getFocusableElements(container);
var first = elements[0];
var last = elements[elements.length - 1];

removeTrapFocus();

trapFocusHandlers.focusin = (event) => {
  if (
    event.target !== container &&
    event.target !== last &&
    event.target !== first
  )
    return;

  document.addEventListener('keydown', trapFocusHandlers.keydown);
};

trapFocusHandlers.focusout = function() {
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
};

trapFocusHandlers.keydown = function(event) {
  if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
  // On the last focusable element and tab forward, focus the first element.
  if (event.target === last && !event.shiftKey) {
    event.preventDefault();
    first.focus();
  }

  //  On the first focusable element and tab backward, focus the last element.
  if (
    (event.target === container || event.target === first) &&
    event.shiftKey
  ) {
    event.preventDefault();
    last.focus();
  }
};

document.addEventListener('focusout', trapFocusHandlers.focusout);
document.addEventListener('focusin', trapFocusHandlers.focusin);

elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
document.querySelector(":focus-visible");
} catch {
focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
let currentFocusedElement = null;
let mouseClick = null;

window.addEventListener('keydown', (event) => {
  if(navKeys.includes(event.code.toUpperCase())) {
    mouseClick = false;
  }
});

window.addEventListener('mousedown', (event) => {
  mouseClick = true;
});

window.addEventListener('focus', () => {
  if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

  if (mouseClick) return;

  currentFocusedElement = document.activeElement;
  currentFocusedElement.classList.add('focused');

}, true);
}

function pauseAllMedia() {
document.querySelectorAll('.js-youtube').forEach((video) => {
  video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
});
document.querySelectorAll('.js-vimeo').forEach((video) => {
  video.contentWindow.postMessage('{"method":"pause"}', '*');
});
document.querySelectorAll('video').forEach((video) => video.pause());
document.querySelectorAll('product-model').forEach((model) => {
  if (model.modelViewerUI) model.modelViewerUI.pause();
});
}

function removeTrapFocus(elementToFocus = null) {
document.removeEventListener('focusin', trapFocusHandlers.focusin);
document.removeEventListener('focusout', trapFocusHandlers.focusout);
document.removeEventListener('keydown', trapFocusHandlers.keydown);

if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

const openDetailsElement = event.target.closest('details[open]');
if (!openDetailsElement) return;

const summaryElement = openDetailsElement.querySelector('summary');
openDetailsElement.removeAttribute('open');
summaryElement.focus();
}

class QuantityInput extends HTMLElement {
constructor() {
  super();
  this.input = this.querySelector('input');
  this.changeEvent = new Event('change', { bubbles: true })

  this.querySelectorAll('button').forEach(
    (button) => button.addEventListener('click', this.onButtonClick.bind(this))
  );
}

onButtonClick(event) {
  event.preventDefault();
  const previousValue = this.input.value;

  event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
  if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
let t;
return (...args) => {
  clearTimeout(t);
  t = setTimeout(() => fn.apply(this, args), wait);
};
}

const serializeForm = form => {
const obj = {};
const formData = new FormData(form);

for (const key of formData.keys()) {
  const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

  if (regex.test(key)) {
    obj.properties = obj.properties || {};
    obj.properties[regex.exec(key)[2]] = formData.get(key);
  } else {
    obj[key] = formData.get(key);
  }
}

return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
return {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
};
}

/*
* Shopify Common JS
*
*/
if ((typeof window.Shopify) == 'undefined') {
window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
return function() {
  return fn.apply(scope, arguments);
}
};

Shopify.setSelectorByValue = function(selector, value) {
for (var i = 0, count = selector.options.length; i < count; i++) {
  var option = selector.options[i];
  if (value == option.value || value == option.innerHTML) {
    selector.selectedIndex = i;
    return i;
  }
}
};

Shopify.addListener = function(target, eventName, callback) {
target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
options = options || {};
var method = options['method'] || 'post';
var params = options['parameters'] || {};

var form = document.createElement("form");
form.setAttribute("method", method);
form.setAttribute("action", path);

for(var key in params) {
  var hiddenField = document.createElement("input");
  hiddenField.setAttribute("type", "hidden");
  hiddenField.setAttribute("name", key);
  hiddenField.setAttribute("value", params[key]);
  form.appendChild(hiddenField);
}
document.body.appendChild(form);
form.submit();
document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
this.countryEl         = document.getElementById(country_domid);
this.provinceEl        = document.getElementById(province_domid);
this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

this.initCountry();
this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
initCountry: function() {
  var value = this.countryEl.getAttribute('data-default');
  Shopify.setSelectorByValue(this.countryEl, value);
  this.countryHandler();
},

initProvince: function() {
  var value = this.provinceEl.getAttribute('data-default');
  if (value && this.provinceEl.options.length > 0) {
    Shopify.setSelectorByValue(this.provinceEl, value);
  }
},

countryHandler: function(e) {
  var opt       = this.countryEl.options[this.countryEl.selectedIndex];
  var raw       = opt.getAttribute('data-provinces');
  var provinces = JSON.parse(raw);

  this.clearOptions(this.provinceEl);
  if (provinces && provinces.length == 0) {
    this.provinceContainer.style.display = 'none';
  } else {
    for (var i = 0; i < provinces.length; i++) {
      var opt = document.createElement('option');
      opt.value = provinces[i][0];
      opt.innerHTML = provinces[i][1];
      this.provinceEl.appendChild(opt);
    }

    this.provinceContainer.style.display = "";
  }
},

clearOptions: function(selector) {
  while (selector.firstChild) {
    selector.removeChild(selector.firstChild);
  }
},

setOptions: function(selector, values) {
  for (var i = 0, count = values.length; i < values.length; i++) {
    var opt = document.createElement('option');
    opt.value = values[i];
    opt.innerHTML = values[i];
    selector.appendChild(opt);
  }
}
};

class MenuDrawer extends HTMLElement {
constructor() {
  super();

  this.mainDetailsToggle = this.querySelector('details');
  const summaryElements = this.querySelectorAll('summary');
  this.addAccessibilityAttributes(summaryElements);

  if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

  this.addEventListener('keyup', this.onKeyUp.bind(this));
  this.addEventListener('focusout', this.onFocusOut.bind(this));
  this.bindEvents();
}

bindEvents() {
  this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
  this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
}

addAccessibilityAttributes(summaryElements) {
  summaryElements.forEach(element => {
    element.setAttribute('role', 'button');
    element.setAttribute('aria-expanded', false);
    element.setAttribute('aria-controls', element.nextElementSibling.id);
  });
}

onKeyUp(event) {
  if(event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if(!openDetailsElement) return;

  openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
}

onSummaryClick(event) {
  const summaryElement = event.currentTarget;
  const detailsElement = summaryElement.parentNode;
  const isOpen = detailsElement.hasAttribute('open');

  if (detailsElement === this.mainDetailsToggle) {
    if(isOpen) event.preventDefault();
    isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
  } else {
    trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
    }, 100);
  }
}

openMenuDrawer(summaryElement) {
  setTimeout(() => {
    this.mainDetailsToggle.classList.add('menu-opening');
  }, 100);
  summaryElement.setAttribute('aria-expanded', true);
  trapFocus(this.mainDetailsToggle, summaryElement);
  document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  document.documentElement.classList.add(`drawer-open`);
}

closeMenuDrawer(event, elementToFocus = false) {
  if (event !== undefined) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.documentElement.classList.remove(`drawer-open`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }
}

onFocusOut(event) {
  setTimeout(() => {
    if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
  }, 100);
}

onCloseButtonClick(event) {
  const detailsElement = event.currentTarget.closest('details');
  this.closeSubmenu(detailsElement);
}

closeSubmenu(detailsElement) {
  detailsElement.classList.remove('menu-opening');
  removeTrapFocus();
  this.closeAnimation(detailsElement);
}

closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
constructor() {
  super();
}

openMenuDrawer(summaryElement) {
  this.header = this.header || document.getElementById('shopify-section-header');
  this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
  document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

  setTimeout(() => {
    this.mainDetailsToggle.classList.add('menu-opening');
  }, 100);

  summaryElement.setAttribute('aria-expanded', true);
  trapFocus(this.mainDetailsToggle, summaryElement);
  document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  document.documentElement.classList.add(`drawer-open`);
}
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
constructor() {
  super();
  this.querySelector('[id^="ModalClose-"]').addEventListener(
    'click',
    this.hide.bind(this)
  );
  this.addEventListener('keyup', (event) => {
    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
  });
  if (this.classList.contains('media-modal')) {
    this.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
    });
  } else {
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
  }
}

show(opener) {
  this.openedBy = opener;
  const popup = this.querySelector('.template-popup');
  document.body.classList.add('overflow-hidden');
  this.setAttribute('open', '');
  if (popup) popup.loadContent();
  trapFocus(this, this.querySelector('[role="dialog"]'));
  window.pauseAllMedia();
}

hide() {
  document.body.classList.remove('overflow-hidden');
  this.removeAttribute('open');
  removeTrapFocus(this.openedBy);
  window.pauseAllMedia();
}
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
constructor() {
  super();

  const button = this.querySelector('button');

  if (!button) return;
  button.addEventListener('click', () => {
    const modal = document.querySelector(this.getAttribute('data-modal'));
    if (modal) modal.show(button);
  });
}
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
constructor() {
  super();
  const poster = this.querySelector('[id^="Deferred-Poster-"]');
  if (!poster) return;
  poster.addEventListener('click', this.loadContent.bind(this));
}

loadContent() {
  window.pauseAllMedia();
  if (!this.getAttribute('loaded')) {
    const content = document.createElement('div');
    content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

    this.setAttribute('loaded', true);
    this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
  }
}
}

// Sticky header
function handlePageScroll() {
  var stickyHeader = $('.custom-header-wrapper'),
    scroll = $(window).scrollTop();
    marginHeight = $('.custom-header-wrapper').height();
  // if (scroll >= marginHeight) {
  if (scroll > 90) {
    stickyHeader.addClass('site-header--sticky site-header--opening');
    $('body').addClass('is-sticking');
    $('body').addClass('is-sticky');
  } else {
    stickyHeader.removeClass('site-header--sticky site-header--opening');
    $('body').removeClass('is-sticking');
    $('body').removeClass('is-sticky');
  }
}

handlePageScroll();

$(window).scroll(function() {
  handlePageScroll();
});

const cartPageCheckoutMain = document.querySelector('.cartPageCheckoutMain');
const checkoutShadowBtn = document.querySelector('.checkoutShadowBtn');
if (cartPageCheckoutMain) {
function handleIntersection(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      // element is in viewport
      document.body.classList.remove('sticky-checkout-button');
    } else {
      // element is out of viewport
      document.body.classList.add('sticky-checkout-button');
    }
  });
}
const observer = new IntersectionObserver(handleIntersection);
observer.observe(cartPageCheckoutMain);

if (checkoutShadowBtn) {
  checkoutShadowBtn.addEventListener('click', (e) => {
    e.preventDefault();
    cartPageCheckoutMain.click();
  })
}
}

const pdpATC = document.querySelector('.pdpATC');
if (pdpATC) {
function handleIntersectionPDP(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      // element is in viewport
      document.body.classList.remove('sticky-atc-button');
    } else {
      // element is out of viewport
      document.body.classList.add('sticky-atc-button');
    }
  });
}
const observer = new IntersectionObserver(handleIntersectionPDP);
observer.observe(pdpATC);
}

const urlParameters = new URLSearchParams(window.location.search);
const productMetaVariants = document.querySelectorAll('.productMetaVariants');
if (productMetaVariants) {
  productMetaVariants.forEach(function(el) {
    var variantTabSwitch = el.querySelectorAll('.variantTabSwitch');
    var variantInput = el.querySelectorAll('.variantInput');
    var upsellsWithFabric = document.querySelectorAll('.pdpAtcModalUpsell[fabrics]');
    if (variantTabSwitch) {
      variantTabSwitch.forEach(function(tab) {
        tab.addEventListener('click', function() {
          let type = tab.querySelector('.variantTabSwitchValue').dataset.value;
          let activeInputs = el.querySelectorAll('.variantInput .swatchColorValue[data-type="' + type + '"]');
          [...tab.parentElement.children].forEach(sib => sib.classList.remove('active'));
          tab.classList.add('active');
          variantInput.forEach(inp => inp.classList.add('is-hidden'));
          activeInputs.forEach(inp => inp.closest('.variantInput').classList.remove('is-hidden'));

          if (upsellsWithFabric) {
            upsellsWithFabric.forEach(ups => {
              let fabrics = ups.getAttribute('fabrics');
              if (fabrics.includes(type)) {
                ups.classList.remove('d-none');
              } else {
                ups.classList.add('d-none');
              }
            })
          }

          if (document.querySelector('.baumwolle-tip') != null) {
            if (type == 'Baumwolle') {
              document.querySelector('.baumwolle-tip').style.display = 'block';
            } else {
              document.querySelector('.baumwolle-tip').style.display = 'none';              
            }
          }
        })
      });
    }
    if (urlParameters && urlParameters.has('fabric-type')) {
      let urlFabricType = urlParameters.get('fabric-type');
      let firstFabricColorTarget = el.querySelector('.swatchColorValue[data-type="' + urlFabricType + '"]');
      let switchers = el.querySelectorAll('.variantTabSwitch');
    
      switchers && variantTabSwitch.forEach(switcher => {
        let fabricType = switcher.querySelector('.variantTabSwitchValue').getAttribute('data-value');
        switcher.classList.toggle('active', fabricType == urlFabricType);
        if (fabricType == urlFabricType) {
          switcher.click();
        }
      });
      if (firstFabricColorTarget) {
        firstFabricColorTarget.closest('.variantInput').querySelector('label').click();
      }
    }
  });
}

// Beeclever
class RemoveSet extends HTMLElement {
constructor() {
  super()
}
connectedCallback(){
  let setId = this.getAttribute('remove-id')
  this.addEventListener('click', async (e) => {
      let keys = Array.from(document.querySelectorAll('[set-id="'+ setId +'"]')).map(element => element.getAttribute('data-key'))
      let updates = {}
      keys.forEach(k => {
          updates[k] = 0
      })
      await fetch('/cart/update.js',{
          method: 'POST',
          body: JSON.stringify({ 
            updates: updates
          }),
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
      })
      localStorage.removeItem(setId);
      document.dispatchEvent(new Event('cart:build')) 
  })
}
}
customElements.define('remove-set', RemoveSet);

const collectionFiltersTrigger = document.querySelector('.collectionFiltersTrigger');
if (collectionFiltersTrigger) {
document.addEventListener('click',function(e){
  if (e.target && (e.target.classList.contains('collectionFiltersTrigger') || e.target.parentElement.classList.contains('collectionFiltersTrigger'))) {
    document.body.classList.toggle('filters-open');
  }
});
}

const collectionFiltersCollapsible = document.querySelector('.collectionFiltersCollapsible');
if (!!collectionFiltersCollapsible && collectionFiltersCollapsible.classList.contains('is-open')) {
document.body.classList.add('filters-open');
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
    });
});
});

const pdpMainATCForm = document.querySelectorAll('.pdpMainATCForm');
const variantRelated = document.querySelectorAll('.variantRelated');
const pdpAtcModalUpsell = document.querySelectorAll('.pdpAtcModalUpsell');
const upsellSwatches = document.querySelectorAll('.upsellSwatch');
const pdpUpsellATC = document.querySelectorAll('.pdpUpsellATC');
const upsellBoxCheck = document.querySelectorAll('.upsellBoxCheck');

function handleModalUpsellsVariantChange(upsells, variant, colorOptionKey) {
  upsells && upsells.forEach((upsellEl) => {
    let swatches = upsellEl.querySelectorAll('.pdpAtcModalUpsellSwatch');
    let selectedColor = upsellEl.querySelector('.upsellUnitColor');
    
    swatches && swatches.forEach(swatch => {
      let color = swatch.getAttribute('color');
      let variantID = swatch.getAttribute('variant-id');
      if (color.includes(variant[colorOptionKey])) {
        upsellEl.setAttribute('variant-id', variantID);
        selectedColor.innerHTML = color;
        swatch.classList.add('active');
      } else {
        swatch.classList.remove('active');
      }
    });
  });
}

function handleModalUpsells(variant, colorOptionKey, upsells) {
  if (variant[colorOptionKey]) {
    upsells && upsells.forEach(upsell => {
      let color = upsell.getAttribute('color');
      if (color) {
        if (color.includes(variant[colorOptionKey])) {
          upsell.classList.remove('d-none');
          upsell.classList.add('is-active');
        } else {
          upsell.classList.add('d-none');
          upsell.classList.remove('is-active');
        }
      }
    });
  }
}

function addItemToCart(items, cback) {
  let formData = {
    items: items
  };
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    typeof cback != 'undefined' && cback();
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

document.addEventListener('variant:change', function(evt) {
  let variant = evt.detail.variant;
  let varID = variant.id;
  let elemsToShow = document.querySelectorAll('.variantRelated[data-variant-id="' + varID + '"]');
  variantRelated && variantRelated.forEach(elem => {
    elem.classList.add('d-none');
  });
  elemsToShow && elemsToShow.forEach(elem => {
    elem.classList.remove('d-none');
  });

  if (variant && colorOptionKey != 'undefined') {
    handleModalUpsells(variant, colorOptionKey, pdpAtcModalUpsell);
    handleModalUpsellsVariantChange(pdpAtcModalUpsell, variant, colorOptionKey)
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (currentVariant && colorOptionKey != 'undefined') {
    handleModalUpsells(currentVariant, colorOptionKey, pdpAtcModalUpsell);
    handleModalUpsellsVariantChange(pdpAtcModalUpsell, currentVariant, colorOptionKey)
  }

  upsellSwatches && upsellSwatches.forEach(swatch => {
    let parentUpsell = swatch.closest('.upsellUnit');  
    let swatches = parentUpsell.querySelectorAll('.upsellSwatch');
    let featuredImage = parentUpsell.querySelector('.upsellUnitImage');
    let selectedColor = parentUpsell.querySelector('.upsellUnitColor');
    let upsellPriceSale = parentUpsell.querySelector('.upsellUnitPriceSale');
    let upsellPriceOld = parentUpsell.querySelector('.upsellUnitPriceOld');
    swatch.addEventListener('click', (e) => {
      let color = swatch.getAttribute('color');
      let variantID = swatch.getAttribute('variant-id');
      let variantImageUrl = swatch.getAttribute('variant-image-url');
      let priceSale = swatch.getAttribute('sale-price');
      let priceOld = swatch.getAttribute('old-price');
      parentUpsell.setAttribute('variant-id', variantID);
      featuredImage && featuredImage.setAttribute('src', variantImageUrl);
      if (selectedColor) selectedColor.innerHTML = color;
      if (upsellPriceSale) upsellPriceSale.innerHTML = priceSale;
      if (upsellPriceOld) upsellPriceOld.innerHTML = priceOld;
      swatch.classList.add('active');
      swatches.forEach(sw => {
        if (sw != swatch) {
          sw.classList.remove('active');
        }
      });
    });
  });

  pdpUpsellATC && pdpUpsellATC.forEach(btn => {
    btn.addEventListener('click', (e) => {
      let upsell = btn.closest('.pdpAtcModalUpsell');
      let upsellImg = upsell.querySelector('.upsellUnitImage');
      let upsellCounter = upsell.querySelector('.pdpUpsellCounter');
      let variantAttr = upsell.getAttribute('variant-id');
      let variantId = variantAttr ? Number(variantAttr) : null;

      if (btn.classList.contains('is-clicked-1st')) {
        let attrs = [{
          'id': variantId,
          'quantity': 1
        }];

        let callBackFunc = () => {
          upsell.classList.add('has-added');
          upsell.classList.remove('is-loading');
          upsell.classList.remove('active');
          btn.classList.add('success');
          btn.classList.remove('is-clicked-1st');
          upsellImg && upsellImg.setAttribute('src', upsellImg.getAttribute('original-src'));
          if (upsellCounter) {
            upsellCounter.innerHTML = Number(upsellCounter.innerHTML) + 1;
          }
          setTimeout(() => {
            btn.classList.remove('success');
          }, 2000)
        }

        upsell.classList.add('is-loading');
        addItemToCart(attrs, callBackFunc);
      } else {
        btn.classList.add('is-clicked-1st');
        upsell.classList.add('active');
      }
    })
  });

  upsellBoxCheck && upsellBoxCheck.forEach(elem => {
    elem.addEventListener('change', evnt => {
      let parentUpsell = elem.closest('.upsellUnit');
      if (elem.checked) {
        parentUpsell.classList.add('selected');
      } else {
        parentUpsell.classList.remove('selected');
      }
    })
  });

  pdpMainATCForm && pdpMainATCForm.forEach(form => {
    form.addEventListener('submit', (evnt) => {
      let selectedUpsells = document.querySelectorAll('.upsellUnit.selected');
      if (selectedUpsells) {
        let proceedToCart = function() {
          form.submit();
        }
        let itemsATCArray = [];
        evnt.preventDefault();
        selectedUpsells.forEach(ups => {
          let variantID = Number(ups.getAttribute('variant-id'));
          let itemAttrs = {
            'id': variantID,
            'quantity': 1
          };
          itemsATCArray.push(itemAttrs);
        });

        addItemToCart(itemsATCArray, proceedToCart);
      }
    });
  });
});

// Open Tildio chat on specific class click
document.addEventListener('click', (e) => {
  if (e.target.classList.contains('openTidioChat')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }
});

class ProductAddonSelector extends HTMLElement {
  constructor() {
    super();
    this.selectedOptionName = this.querySelector('.addonSelectedValue');
    this.option = this.querySelectorAll('.addonSelector');
  }

  connectedCallback() {
    this.option && this.option.forEach((el) => {
      el.addEventListener('change', (e) => {
        const value = el.getAttribute('title');
        this.selectedOptionName.innerHTML = value;
      });
    });
  }
}
customElements.define('product-addon-selector', ProductAddonSelector);

document.addEventListener('DOMContentLoaded', () => {
  if (navigator.userAgent.indexOf('Mac OS X') != -1) {
    document.documentElement.classList.add('is-macos');
  }
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    document.documentElement.classList.add('is-ios');
  }
  if (/Firefox/.test(navigator.userAgent)) {
    document.documentElement.classList.add('is-firefox');
  }
});

var MarqueeText = class extends HTMLElement {
constructor() {
  super();
  if (window.ResizeObserver) {
    new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
  }
}
_calculateDuration(entries) {
  const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5), contentWidth = entries[0].contentRect.width, slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
  this.style.setProperty("--marquee-animation-duration", `${(scrollingSpeed * slowFactor * entries[0].target.querySelector("span").clientWidth / contentWidth).toFixed(3)}s`);
}
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

function handleCartDiscountMessage(bannerEl, code) {
  bannerEl && bannerEl.forEach(el => {
    let codeNameEl = el.querySelector('.dCodeName');
    let codePercentEl = el.querySelector('.dCodePercent');

    if (code.title && codeNameEl) {
      codeNameEl.innerHTML = code.title;
    }
    if (code.percentageOfSubtotal && codePercentEl) {
      codePercentEl.innerHTML = code.percentageOfSubtotal;
    }

    if (code.title && codeNameEl && code.percentageOfSubtotal && codePercentEl) {
      el.classList.remove('d-none');
    }
  });
}

document.body.addEventListener('docapp-discount-success', (e) => {
  console.log(e.code);

  const dCodeBanner = document.querySelectorAll('.dCodeBanner');
  const discountRelatedUpsells = document.querySelector('.discountRelatedUpsells');
  const cartUpsellsMessage = document.querySelector('.cartUpsellsMessage');

  handleCartDiscountMessage(dCodeBanner, e.code);
  document.body.classList.remove('docapp-discount-failed');
  
  if (discountRelatedUpsells) {
    let appliccableCodes = discountRelatedUpsells.getAttribute('data-codes');
    if (appliccableCodes.includes(e.code.title) && code.isBuyXGetY && upsellMessage && ! upsellMessage.classList.contains('d-none')) {
      cartUpsellsMessage.scrollIntoView();
    }
  }
});

document.body.addEventListener('docapp-discount-failure', (e) => {
  console.log(e.code);
  const cartUpsellsMessage = document.querySelector('.cartUpsellsMessage');
  const discountRelatedUpsells = document.querySelector('.discountRelatedUpsells');
  handleCartDiscountMessage(null, e.code);
  document.body.classList.add('docapp-discount-failed');
  if (discountRelatedUpsells) {
    let appliccableCodes = discountRelatedUpsells.getAttribute('data-codes');
    if (appliccableCodes.includes(e.code)) {
      cartUpsellsMessage.classList.remove('d-none');
      cartUpsellsMessage.scrollIntoView();
    }
  }
});

const showAllSwatches = document.querySelectorAll('.showAllSwatches');
if (showAllSwatches) {
  showAllSwatches.forEach(el => {
    el.addEventListener('click', function (e) {
      let wrapper = el.parentElement;
      let hiddenSwatches = wrapper.querySelectorAll('.hiddenSwatch');
      e.preventDefault();
      e.stopPropagation();
      e.target.classList.add('hide');
      hiddenSwatches.forEach(swt => {
        swt.classList.remove('hide');
      })
    })
  })
}